export const SET_TYPE_JOB_DETAIL = "SET_TYPE_JOB_DETAIL";
